module.exports = __webpack_public_path__ + "static/media/terms_conditions_privacy_policy_IT.7e6a8466.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/terms_conditions_privacy_policy_IT.pdf
// module id = 316
// module chunks = 5